import { render, staticRenderFns } from "./comment-pay-calculator-snapshot.vue?vue&type=template&id=3965ecc8"
import script from "./comment-pay-calculator-snapshot.vue?vue&type=script&lang=js"
export * from "./comment-pay-calculator-snapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports